__turbopack_context__.v({
  "contact": "home-module__fTAmxG__contact",
  "container": "home-module__fTAmxG__container",
  "form": "home-module__fTAmxG__form",
  "hero": "home-module__fTAmxG__hero",
  "list": "home-module__fTAmxG__list",
  "section": "home-module__fTAmxG__section",
});
